// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ha-3";
export var downloadButton = "_ha-4";
export var fileContainer = "_ha-9 _ha-7";
export var fileContainerBase = "_ha-7";
export var fileContainerBaseSm = "_ha-a _ha-7";
export var fileContainerFixedHeight = "_ha-8 _ha-7";
export var fileContainerFixedHeightSm = "_ha-c _ha-a _ha-7";
export var fileContainerSm = "_ha-b _ha-a _ha-7";
export var fileInfo = "_ha-5";
export var fileInfoWidthRestricted = "_ha-6";
export var fileType = "_ha-1";
export var fileTypeName = "_ha-2";
export var fileTypeSm = "_ha-d _ha-1";
export var image = "_ha-0";
export var link = "_ha-f";
export var overflowEllipsis = "_ha-e";